import { Helmet } from "react-helmet-async";

const Terms = () => (
  <>
    <Helmet>
      <title>Terms of Service | Elevate Global Solutions</title>
      <meta name="description" content="Terms of service for engagements with Elevate Global Solutions, including scope, payment, and guarantees." />
      <link rel="canonical" href="https://www.elevateglobalsolutions.net/terms" />
    </Helmet>
    <section className="section-padding">
      <div className="container-narrow max-w-3xl">
        <div className="gold-divider" />
        <h1 className="mt-4 font-display text-4xl font-bold text-foreground">Terms of Service</h1>
        <p className="mt-2 text-sm text-muted-foreground">Last updated: May 2026</p>

        <div className="prose prose-neutral mt-8 max-w-none text-foreground">
          <h2 className="mt-8 font-display text-xl font-bold">1. Engagements</h2>
          <p className="mt-2 text-muted-foreground">
            All service engagements are month-to-month unless otherwise agreed in writing. Scope,
            KPIs, and pricing are defined in your individual Service Agreement.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">2. Payment</h2>
          <p className="mt-2 text-muted-foreground">
            Invoices are billed monthly in advance. Engagements may be paused or cancelled with a
            7-day written notice.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">3. Performance & guarantees</h2>
          <p className="mt-2 text-muted-foreground">
            We guarantee dial volume, contact rates, and quality standards documented in your
            Service Agreement. Any underperforming team member is replaced at no additional cost.
            We do not guarantee deals or revenue outcomes.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">4. Confidentiality</h2>
          <p className="mt-2 text-muted-foreground">
            Each team member signs a confidentiality agreement before accessing your CRM, lists, or
            scripts. We never share client data across accounts.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">5. Compliance</h2>
          <p className="mt-2 text-muted-foreground">
            You remain responsible for TCPA, DNC, and state-level call compliance for your lists.
            We follow your script and calling-window directives.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">6. Contact</h2>
          <p className="mt-2 text-muted-foreground">
            Elevate Global Solutions · abdelrahaman@elevateglobalsolutions.net · (214) 296-2124
          </p>
        </div>
      </div>
    </section>
  </>
);

export default Terms;
